import RoofSnapApiClient from './roofSnapApiClient';

const baseUrl = "sketchordertiers";

class SketchOrderTierClient extends RoofSnapApiClient {
    async getSketchOrderTier() {
        const sketchOrders = await super.get(baseUrl);
        return sketchOrders;
    }
}

export default SketchOrderTierClient;
